module.exports = __webpack_public_path__ + "img/nearcode_cut.6bd180a9.png";